import type { FaireProductEntity } from "../../entity_types/product";

export const p_2jh9x3vr3s: FaireProductEntity = {
  token: "p_2jh9x3vr3s",
  type: "product",
  name: "Coop's Original Hot Fudge",
  brandToken: "b_27yaz87n28",
  brandName: "Coop's",
  imageUrl:
    "https://cdn.faire.com/fastly/0959b261128d0eb7debb10c19ef04428dfe148a469b25ed0b5da5f7561fe3785.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/fb9b9f395a178bbb50b62de98d7ec642eefcfb56b9dbe826915a19e06a3fd64a.jpeg",
    "https://cdn.faire.com/fastly/0c56124c221c6b4635bd43bf261f8788d4229a14843dc10865db1cd1ccd07645.jpeg",
    "https://cdn.faire.com/fastly/93672465ba4c66017da679d205b3386ca44299ad22bf8d3108c2dac5fcdb0a38.jpeg",
    "https://cdn.faire.com/fastly/bc8f7cd173fa9c48e1eede0737254bc5d06e0687b27266ffad8d693bdc903c4d.png",
    "https://cdn.faire.com/fastly/0bfd7d3a81a857f04e8ca0329a64750870be6cd904bcdf6cc9bcea90da9cd2fa.jpeg",
    "https://cdn.faire.com/fastly/63acbeba1ba490a8f9ca7bb33b023918ed52668c18928465a307e7b1ca2e5977.png",
  ],
  priceDollars: 7.6,
  description:
    "Hot fudge is a sauce so iconic, we knew we had to spend the time to get it right. So, we’ve been mastering the craft since 2010. \n\nHandmade in small batches with high-grade European chocolate and pure dairy, Coop’s Original Hot Fudge is a jar of ooey-gooey nostalgia. Deep and dark, this indulgent sauce has just the right touch of sweetness—unlike sugary supermarket brands that leave an artificial taste on your tongue. \n\nIt’s instantly rich and impeccably smooth, thick right out of the jar but drizzly once warmed. Atop ice cream it hardens to the perfect soft chew, but we don’t stop there—spread it on brownies, drip it over fruit, plunge your pretzels into it or devour it straight by the spoonful. Just don’t be surprised if it disappears quickly.\n\nWhile this was clearly designed to top ice cream (and it does so beautifully), we’ve been devouring cold spoonfuls of the ganache-like fudge straight from the container. – THE BOSTON GLOBE",
  tags: [],
  msrpDollars: 13.7,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-09T05:16:55.481Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
